
import { Options, Vue } from "vue-class-component";
import Alert from "@/components/Alert.vue";
import Game from "@/components/Game.vue";
import Menu from "@/components/Menu.vue";
import { emptyGame, GameRules, GameState } from "./GameState";
import { exportState, importState } from "./GameStorage";

@Options({
  data() {
    return {
      inMenu: true,
      state:
        localStorage.lastState && process.env.NODE_ENV === "production"
          ? importState(localStorage.lastState)
          : undefined,
      copyright: "",
      stateStack: [],
    };
  },
  watch: {
    state: {
      handler(current) {
        if (current !== undefined) {
          const ex = exportState(current);
          (this as App).stateStack.push(ex);
          localStorage.lastState = ex;
        }
      },
      deep: true,
    },
  },
  components: {
    Alert,
    Game,
    Menu,
  },
})
export default class App extends Vue {
  private copyright!: string;
  private inMenu!: boolean;
  private state?: GameState;
  private stateStack!: string[];

  startGame(rules: GameRules) {
    this.inMenu = false;
    this.state = emptyGame(rules);
    this.stateStack = [];
  }

  backGame() {
    if (this.state !== undefined) {
      this.inMenu = false;
    }
  }

  // called when service worker has updated
  offerReload() {
    (this.$refs.offer as Alert).showModal = true;
  }

  reloadNow() {
    location.reload();
  }

  // update copyright every 10s
  mounted() {
    this.randomCopyright();
  }

  randomCopyright() {
    // shuffle names
    const names = ["Magnus Kühn", "Robert Junge", "Hazem Riahi"];
    for (let i = names.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      const temp = names[i];
      names[i] = names[j];
      names[j] = temp;
    }

    this.copyright = names.join(", ") + " " + new Date().getFullYear();

    // update copyright every 10s while tab is active
    requestAnimationFrame(() =>
      setTimeout(this.randomCopyright.bind(this), 10000)
    );
  }

  undo() {
    // the current state is on top of the stack
    this.stateStack.pop();

    // also remove the previous state as it will be readded by the watcher
    const ex = this.stateStack.pop();
    if (ex !== undefined) {
      this.state = importState(ex);

      // go to menu in case of failure
      this.inMenu = this.state === undefined;
    }
  }
}
